import { Tooltip, TooltipTrigger } from "@light-technology/components";
import { type ReactNode } from "react";

type TruncatedTextProps = {
  content: string;
  children?: ReactNode;
  className?: string;
  badge?: ReactNode;
};

export const TruncatedText = ({
  content,
  children,
  className,
  badge,
}: TruncatedTextProps) => {
  const tooltipElement = (
    <Tooltip title={content}>
      <TooltipTrigger className={badge ? "min-w-0 flex-1" : "block w-full"}>
        <div className="truncate text-left">
          <span className={className}>{children ?? content}</span>
        </div>
      </TooltipTrigger>
    </Tooltip>
  );

  return badge ? (
    <div className="flex min-w-0 items-center gap-2">
      {tooltipElement}
      {badge}
    </div>
  ) : (
    tooltipElement
  );
};
